module.exports = "<p>\r\n  cosa-facciamo works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cosa-facciamo/cosa-facciamo.component.html
// module id = ./src/app/cosa-facciamo/cosa-facciamo.component.html
// module chunks = main